// extracted by mini-css-extract-plugin
module.exports = {"playerContainer":"video-player_playerContainer__Af_Kl","videoPlayer":"video-player_videoPlayer__CKg3J"};